export default __webpack_public_path__ + "static/media/img_bg.fbb9c9dd.png";